import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { OnClick } from "../dom-tools/EventListeners";
import { HTMLEditor } from "../dom-tools/HTMLEditor";
import { ScrollLock } from "./ScrollLock";

export class PortraitMenu
{
  static readonly attribute = new ElementAttribute( "portrait-menu" );
  static readonly assignedAttribute = new ElementAttribute( "portrait-menu-assigned" );
  static readonly blockDurationMS = 300;

  static applyOnDocument()
  {
    PortraitMenu.hide();
    PortraitMenu.attribute.forAll( document.body, ( e ) => PortraitMenu.applyOnElement( e ) );
    
  }

  static hide()
  {
    ScrollLock.disable();
  }

  static toggle( element:Element, classElement:Element, className:string, now:number )
  {
    PortraitMenu.assignedAttribute.to( element, now + "");

    HTMLEditor.toggleClass( classElement, className );

    let isOpen = HTMLEditor.hasClass( classElement, className );

    let changeOverFlow = ()=>
    { 
      ScrollLock.set( isOpen );
      classElement.removeEventListener( "transitionend", changeOverFlow );
    }

    classElement.addEventListener( "transitionend", changeOverFlow );
  }

  static applyOnElement( element:Element )
  { 
    if ( PortraitMenu.assignedAttribute.in( element ) )
    {
      return;
    }


    PortraitMenu.assignedAttribute.to( element, "0" );

    let parameters = PortraitMenu.attribute.from( element ).split( ";" );
    let selector = parameters[ 0 ];
    let className = parameters[ 1 ];
    let classElement = document.querySelector( selector );

    OnClick.add( classElement as HTMLElement, 
      ()=>
      {
        setTimeout(
          ()=>
          {
            PortraitMenu.toggle( element, classElement, className, new Date().getTime() );
          },
          100
        )
       
      }
    );
    

    let action = ()=>
    {
      let now = new Date().getTime();
      let time = parseFloat( PortraitMenu.assignedAttribute.from( element ) );
      let elapsed = now - time;

      if ( elapsed < PortraitMenu.blockDurationMS )
      {
        return;
      }

      PortraitMenu.toggle( element, classElement, className, now );
      
        
    }

    HTMLEditor.onClick( element, action );


  }

}